import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';

import Input from '../../../components/Forms/Input';
import { Wrap, Links } from './styles';
import Icon from '../../../components/Icon';
import PageSectionDivider from '../../../components/Layout/Content/PageSectionDivider';

const Inspiration = ({ inspirationLinks, setInspirationLinks }) => {
  const [value, setValue] = useState('');

  function isValidUrl(text) {
    return /\b(http|https)/.test(text);
  }

  const onKeyUp = ({ key }) => {
    if (key === 'Enter') {
      setInspirationLinks([...inspirationLinks, value]);
      setValue('');
    }
  };

  const handleClick = url => {
    const val = isValidUrl(url);
    if (val) {
      window.open(url, '_blank');
    } else window.open(`https://${url}`, '_blank');
  };

  const handleDelete = urlToRemove => {
    setInspirationLinks(inspirationLinks.filter(url => url !== urlToRemove));
  };

  return (
    <Wrap>
      <Input
        label="Inspiration"
        placeholder="https://some-image.url/photo.png"
        width="750px"
        value={value}
        onChange={setValue}
        onKeyUp={onKeyUp}
      />
      <Links>
        {inspirationLinks.map((url, i) => (
          <Chip
            key={`${url}-${i}`}
            size="small"
            icon={<Icon name="link" />}
            label={url}
            onClick={() => handleClick(url)}
            onDelete={() => handleDelete(url)}
          />
        ))}
      </Links>

      <PageSectionDivider size="S" />
    </Wrap>
  );
};

Inspiration.propTypes = {
  inspirationLinks: PropTypes.arrayOf(PropTypes.string).isRequired,
  setInspirationLinks: PropTypes.func.isRequired,
};

export default Inspiration;
